import { RepositoryFactory } from 'repository/RepositoryFactory';

let GuestRepository = RepositoryFactory.get('guest');

export const getAllGuests = (id) => async (dispatch) => {

  try {
    let { data } = await GuestRepository.getAllGuestWalls(id);

    if (data.success) {
      dispatch({
        type: 'GET_GUEST_WALLS',
        payload: data.data
      });
    }
  } catch (err) {
    console.log('error', err.message);
  }
};
export const updateGuestWall = (payload, blId) => async (dispatch) => {

  try {
    let res = await GuestRepository.updateGuestWall(payload);
    if (res?.data?.success) {
      // alert('Guest Wall Updated succesfully');
      dispatch(getAllGuests(blId));
    }
    return res?.data?.success;
  } catch (err) {
    console.log('error', err.message);
  }
};
export const deleteGuestWall = (payload, blId) => async (dispatch) => {

  try {
    let res = await GuestRepository.deleteGuestWall(payload);
    if (res?.data?.success) {
      // alert('Guest Wall Deleted succesfully');
      dispatch(getAllGuests(blId));
    }
    return res?.data?.success;
  } catch (err) {
    console.log('error', err.message);
  }
};
